export const DEFAULT_ACTIVE_TAB_ID = '2'
